// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BKc--keyboardMode--outline,html[data-focus-by=key] ._9s--keyboardMode--outlineWhenFocused:focus,html[data-focus-by=key] .kyk--keyboardMode--outlineWhenFocusedWithin:focus-within{outline:2px solid var(--uikit-color-grey-alpha50);outline-offset:2px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outline": "BKc--keyboardMode--outline",
	"outlineWhenFocused": "_9s--keyboardMode--outlineWhenFocused",
	"outlineWhenFocusedWithin": "kyk--keyboardMode--outlineWhenFocusedWithin"
};
module.exports = ___CSS_LOADER_EXPORT___;
